export { CardHeader, CardBody, CardFooter, ResponsiveCard } from "./Card";
export type { CardProps } from "./Card";
import Card from "./Card";
export default Card;
